exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.icon .icon-path[data-v-198a2b19] {\n  fill: #1E1D32;\n}\n.icon .icon-code[data-v-198a2b19],\n.icon .icon-link[data-v-198a2b19] {\n  stroke: #1E1D32;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-198a2b19","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Icons.vue
// module id = O0fR
// module chunks = 1